
export const COMPETITOR_ANALYSIS_PROMPT = `你是一位资深的亚马逊市场分析专家，拥有丰富的竞品分析和选品经验。请基于以下关键词搜索数据，进行深度竞争分析。

# 数据概览
## 整体统计（已按ASIN去重）
- 去重ASIN数量: {{global_stats.unique_asins}}
- 去重品牌数量: {{global_stats.unique_brands}}
- 总销量: {{global_stats.total_sales}}
- 总销售额: {{global_stats.total_revenue}}美元
- 平均价格: {{global_stats.avg_price}}美元
- 平均评分: {{global_stats.avg_rating}}
- 平均上架天数: {{global_stats.avg_days}}天

## 价格区间分布
{{price_range_distribution}}

## 关键词详情
{{keywords_detail}}

# 分析要求
请从以下维度进行全面分析，输出详尽的竞争分析报告：

## 1. 市场规模与机会评估
- 整体市场容量估算和增长潜力
- 各价格带的市场机会点
- 最佳进入价格区间建议

## 2. 品牌竞争格局
- 头部品牌分析（市场集中度）
- 中小品牌生存空间
- 新品牌进入壁垒

## 3. 产品结构分析
- 各价格区间的产品特征
- 高销量产品的共性（评分、上架时间、价格）
- 产品差异化机会点

## 4. 定价策略建议
- 最优定价区间
- 价格与销量的关系洞察
- 促销定价建议

## 5. 新品进入策略
- 推荐的产品定位
- 建议的首发价格
- 预期月销量和销售额目标
- 关键成功因素

## 6. 风险与挑战
- 主要竞争风险
- 市场饱和度评估
- 应对建议

# 输出格式
请输出结构清晰的Markdown格式分析报告，使用标题、列表、加粗等格式增强可读性。每个分析点都要有具体的数据支撑和明确的建议。`;
